import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';

import { AdvancedFilterPropsPestSightings, AdvancedFilterPropsVulnerabilities } from './type';

interface MCTMonitoringFilterProps {
  filterType: string;
  setFilterType: (value: string) => void;
  isSighting?: boolean;
}

const AdvancedFilter: React.FC<MCTMonitoringFilterProps> = ({ filterType, setFilterType, isSighting }) => {
  const filterObject = isSighting ? AdvancedFilterPropsPestSightings : AdvancedFilterPropsVulnerabilities;
  const CustomSelect = styled(Select)({
    '&.MuiInputBase-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderColor: 'red',
    },
    '& .MuiSelect-select': {
      padding: '10px 12px',
      paddingRight: '24px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E0E0E0',
    },
  });

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setFilterType(event.target.value as AdvancedFilterPropsPestSightings | AdvancedFilterPropsVulnerabilities);
  };

  const filters = Object.keys(filterObject);
  return (
    <div className="buttons mt-2 mt-lg-0">
      <FormControl sx={{ width: '100%' }}>
        <InputLabel
          id="demo-simple-select-standard-label"
          sx={{ fontFamily: 'Poppins, sans-serif', width: '100%' }}
          shrink
        >
          Current filter applied
        </InputLabel>
        <CustomSelect
          value={filterType}
          onChange={handleChange}
          id="demo-simple-select-filled"
          label="Current Filter Applied"
          sx={{
            width: 250,
            fontFamily: 'Poppins, sans-serif',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--vz-purple)',
            },

            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--vz-purple)',
            },
          }}
        >
          {filters.map(key => (
            <MenuItem key={key} value={key} sx={{ fontFamily: 'Poppins, sans-serif' }}>
              {filterObject[key as keyof typeof filterObject]}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </div>
  );
};

export default AdvancedFilter;
